import { defineMessages } from 'react-intl';

export const scope = 'app.containers.transactions';

export default defineMessages({
  transaction_download_success_status_header: {
    id: `${scope}.transaction_download_success_status_header`,
    defaultMessage: 'Download Complete',
  },
  transaction_download_success_status_summary: {
    id: `${scope}.transaction_download_success_status_summary`,
    defaultMessage: 'Transactions downloaded successfully',
  },
  transaction_download_failed_status_header: {
    id: `${scope}.transaction_download_failed__status_header`,
    defaultMessage: 'Download Failed',
  },
  transaction_download_failed_status_summary: {
    id: `${scope}.transaction_download_failed_status_summary`,
    defaultMessage: 'Unable to download. Try again.',
  },
});
